import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/style.css';
import './styles/flatsome.css';
import './styles/flatsome-shop.css';
import './styles/globals.css';
import './styles/datatables.css';
import './styles/wcf-frontend.css';
import './styles/custom-theme.css';
// Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/free-mode";
import "swiper/css/thumbs";
import reportWebVitals from './reportWebVitals';
import { getCurrentStoreConfig } from './tenant';

const storeConfig = getCurrentStoreConfig();
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
     <App store={storeConfig} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
